/*
 * Copyright (c) 2023 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, April 20th 2023, 10:11:06 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import Stack from "@mui/material/Stack";

interface CenterProps {
  children: React.ReactNode;
}

export const Center = ({ children }: CenterProps) => (
  <Stack justifyContent="center" justifyItems="center" alignItems="center">
    {children}
  </Stack>
);
